<section class="padding-70px-tb bg-dark-blue contact-form-style2 border-none xs-padding-60px-tb" id="contact">
    <div class="container">
        <div class="row ">
            <!-- section title -->
            <div class="col-md-6 col-sm-12 col-12  wow fadeInLeft">
                <h2
                    class="section-title-large text-center sm-section-title-medium xs-section-title-large text-white font-weight-600 alt-font margin-six-bottom xs-margin-fifteen-bottom">
                    Contáctenos</h2>
                <!-- <div
                    class="text-medium width-90 sm-width-100 center-col margin-thirteen-bottom text-white  xs-margin-nineteen-bottom">
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                    industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type.
                </div> -->
                <div class="row  xs-margin-thirteen-bottom sm-margin-thirteen-bottom  margin-seven-bottom  margin-ten-top  fadeInUp"
                    style="visibility: visible; animation-name: fadeInUp;">
                    <div class="feature-box xs-margin-thirteen xs-no-margin-tb text-center col-2 ">
                        <i
                            class="fas fa-map-marker-alt text-white icon-large margin-ten-bottom xs-margin-three-bottom"></i>

                    </div>
                    <div class="text-light-gray text-medium alt-font col-8">San Jorge Nro. 254 <br>
                        Asunción, Paraguay</div>
                </div>

                <div class="row  xs-margin-thirteen-bottom sm-margin-thirteen-bottom margin-seven-bottom wow fadeInUp"
                    style="visibility: visible; animation-name: fadeInUp;">
                    <div class="feature-box xs-margin-thirteen xs-no-margin-tb text-center col-2 ">
                        <i class="fas fa-mobile-alt text-white icon-large margin-ten-bottom xs-margin-three-bottom"></i>

                    </div>
                    <div class="text-light-gray text-medium alt-font col-8"> +5959 86 108 591 </div>
                </div>

                <div class="row  xs-margin-thirteen-bottom sm-margin-thirteen-bottom margin-seven-bottom wow fadeInUp"
                    style="visibility: visible; animation-name: fadeInUp;">
                    <div class="feature-box xs-margin-thirteen xs-no-margin-tb text-center col-2 ">
                        <i class="far fa-envelope text-white icon-large margin-ten-bottom xs-margin-three-bottom"></i>

                    </div>
                    <div class="text-light-gray text-medium alt-font col-8"> ventas@servios.com.py</div>
                </div>

                <div class="row  xs-margin-thirteen-bottom sm-margin-thirteen-bottom margin-seven-bottom wow fadeInUp"
                    style="visibility: visible; animation-name: fadeInUp;">
                    <div class="feature-box xs-margin-thirteen xs-no-margin-tb text-center col-2 ">
                        <i class="fab fa-facebook-f text-white icon-large margin-ten-bottom xs-margin-three-bottom"></i>

                    </div>
                    <div class="text-light-gray text-medium alt-font col-8"> <a class="text-light-gray" target="_blank"
                            href="https://www.facebook.com/s.e.r.v.i.o.s.py/">
                            @s.e.r.v.i.o.s.py</a></div>
                </div>

                <div class="row  xs-margin-thirteen-bottom sm-margin-thirteen-bottom margin-seven-bottom wow fadeInUp"
                    style="visibility: visible; animation-name: fadeInUp;">
                    <div class="feature-box xs-margin-thirteen xs-no-margin-tb text-center col-2 ">
                        <i class="fab fa-instagram text-white icon-large margin-ten-bottom xs-margin-three-bottom"></i>

                    </div>
                    <div class="text-light-gray text-medium alt-font col-8"> <a class="text-light-gray" target="_blank"
                            href="https://www.instagram.com/s.e.r.v.i.o.s/">
                            @s.e.r.v.i.o.s</a> </div>
                </div>

            </div>
            <!-- end section title -->
            <!-- contact form  -->
            <div class="col-md-6 col-sm-12 col-12 text-center wow fadeInRight">
                <h2
                    class="section-title-medium sm-section-title-medium xs-section-title-medium text-white font-weight-600 alt-font margin-six-bottom xs-margin-fifteen-bottom">
                    Envíenos un mensaje</h2>
                <form ngNativeValidate #f="ngForm" (ngSubmit)="sendEmail( f )" class="width-100">
                    <input type="text" name="nombre" [(ngModel)]="nombre" required placeholder="* Nombre y apellido"
                        class="medium-input border-radius-4">
                    <input type="email" name="correo" [(ngModel)]="correo" placeholder="Correo electrónico"
                        class="medium-input border-radius-4 width-45" style="margin-right: 10%;">
                    <input type="text" name="telefono" [(ngModel)]="telefono" required placeholder="Número de contacto"
                        class="medium-input border-radius-4 width-45">
                    <input type="text" name="asunto" [(ngModel)]="asunto" required placeholder="* Asunto"
                        class="medium-input border-radius-4">
                    <textarea rows="4" name="mensaje" [(ngModel)]="mensaje" placeholder="Escriba su mensaje.."
                        class="medium-input border-radius-4" required></textarea>
                    <button type="submit" class="btn btn-large bg-red btn-3d text-white">
                        <i class="fas fa-paper-plane"></i>
                        Enviar
                        mensaje</button>
                </form>
            </div>
            <!-- end contact form  -->
        </div>
    </div>
</section>